var _excluded = ["context", "middlewareData", "placement", "refs", "strategy", "x", "y"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useRef, useState } from 'react';
import { arrow, autoUpdate, flip, offset, safePolygon, shift, useFloating, useFocus, useHover, useInteractions } from '@floating-ui/react-dom-interactions';
import getPopoverStyles from '../getPopoverStyles';

function usePopover(_ref) {
  var openOnFocus = _ref.openOnFocus,
      openOnHover = _ref.openOnHover,
      openOnMount = _ref.openOnMount,
      placement = _ref.placement,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen;

  var _useState = useState(openOnMount),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var handleClose = function handleClose(e) {
    setOpen(false);
    if (onClose) onClose(e);
  };

  var handleOpen = function handleOpen(open) {
    setOpen(open);
    open && onOpen && onOpen();
    !open && onClose && onClose();
  };

  var handleToggle = function handleToggle(evt) {
    setOpen(function (isOpen) {
      isOpen ? onClose === null || onClose === void 0 ? void 0 : onClose(evt) : onOpen === null || onOpen === void 0 ? void 0 : onOpen(evt);
      return !isOpen;
    });
  };

  var arrowRef = useRef(null);

  var _useFloating = useFloating({
    open: isOpen,
    placement: placement,
    middleware: [offset(8), flip({
      fallbackPlacements: ['top', 'right', 'bottom', 'left', 'top']
    }), shift({
      padding: 8
    }), arrow({
      element: arrowRef
    })],
    whileElementsMounted: autoUpdate,
    onOpenChange: handleOpen
  }),
      context = _useFloating.context,
      middlewareData = _useFloating.middlewareData,
      actualPlacement = _useFloating.placement,
      refs = _useFloating.refs,
      strategy = _useFloating.strategy,
      x = _useFloating.x,
      y = _useFloating.y,
      floatingValues = _objectWithoutProperties(_useFloating, _excluded);

  var _useInteractions = useInteractions([useFocus(context, {
    enabled: !!openOnFocus || !!openOnHover
  }), useHover(context, {
    enabled: !!openOnHover,
    handleClose: safePolygon()
  })]),
      getFloatingProps = _useInteractions.getFloatingProps,
      getReferenceProps = _useInteractions.getReferenceProps;

  var _ref2 = (middlewareData === null || middlewareData === void 0 ? void 0 : middlewareData.arrow) || {},
      arrowX = _ref2.x,
      arrowY = _ref2.y;

  var styles = getPopoverStyles({
    arrowX: arrowX,
    arrowY: arrowY,
    placement: actualPlacement,
    refs: refs,
    strategy: strategy,
    x: x,
    y: y
  });
  return _objectSpread(_objectSpread({}, floatingValues), {}, {
    arrowRef: arrowRef,
    isPopoverOpen: isOpen,
    placement: actualPlacement,
    styles: styles,
    getFloatingProps: getFloatingProps,
    getReferenceProps: getReferenceProps,
    handleClose: handleClose,
    handleToggle: handleToggle
  });
}

export default usePopover;